import React, { useState, useEffect } from 'react';
import {
  Card, 
  CardBody, 
  Row,
  Col, 
  label,
} from 'reactstrap';  
import { useTranslation } from 'react-i18next';    
import PageContent from 'layouts/PageContent';
import MonthlyDowntimeSummaryTrend from './MonthlyDowntimeSummaryTrend';

const MonthlyDowntimeSummaryScreen = (props) => { 
  /* ################## useState area start ################## */
  const { t } = useTranslation(['productionDashboard', 'common']);
   
    /* ################## End useState area start ################## */
 
 
  return (
    <>
      <PageContent title={t('productionDashboard:MonthlyDowntimeSummaryScreen')}>   
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>  
            <MonthlyDowntimeSummaryTrend 
              Fecha={null}
              ClaUbicacion={68} // default mid continent
              ClaArea={null}
              ClaCelda={null}
              ClaTurno={null}
              DisableFilters={false}
            >
            </MonthlyDowntimeSummaryTrend>
          </Col> 
        </Row>  
      </PageContent>
    </>
  );
};

export default MonthlyDowntimeSummaryScreen;
